import React, { useState, useEffect } from "react";

const icons = ["fa-code", "fa-microchip", "fa-bug", "fa-database", "fa-robot", "fa-laptop-code"];
const pairs = [...icons, ...icons].sort(() => Math.random() - 0.5);

export default function MemoryGame() {
    const [flipped, setFlipped] = useState([]);
    const [matched, setMatched] = useState([]);
    const [timeLeft, setTimeLeft] = useState(60);

    useEffect(() => {
        if (timeLeft > 0 && matched.length < pairs.length) {
            const timer = setTimeout(() => setTimeLeft(t => t - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [timeLeft, matched]);

    const handleClick = (index) => {
        if (flipped.length === 2 || flipped.includes(index) || matched.includes(index)) return;
        const newFlipped = [...flipped, index];
        setFlipped(newFlipped);
        if (newFlipped.length === 2) {
            const [a, b] = newFlipped;
            if (pairs[a] === pairs[b]) {
                setMatched([...matched, a, b]);
            }
            setTimeout(() => setFlipped([]), 800);
        }
    };

    const resetGame = () => {
        setMatched([]);
        setFlipped([]);
        setTimeLeft(60);
    };

    return (
        <div style={{
            textAlign:"center",
            color:"#fff",
            background:"rgba(255,255,255,0.05)",
            padding:"1rem",
            borderRadius:"1rem",
            boxShadow:"0 0 25px rgba(0,255,200,0.15)"
        }}>
            <h4 style={{color:"#a855f7", marginBottom:"0.5rem"}}><i className="fas fa-puzzle-piece"></i> Memory Tech</h4>
            <p>⏱️ Tempo: {timeLeft}s — 🔥 Coppie trovate: {matched.length / 2}</p>

            <div style={{
                display:"grid",
                gridTemplateColumns:"repeat(4, 60px)",
                gap:"10px",
                justifyContent:"center",
                marginTop:"10px"
            }}>
                {pairs.map((icon, i) => {
                    const isVisible = flipped.includes(i) || matched.includes(i);
                    return (
                        <div key={i}
                             onClick={() => handleClick(i)}
                             style={{
                                 width:"60px", height:"60px",
                                 borderRadius:"0.5rem",
                                 background:isVisible ? "rgba(0,255,180,0.2)" : "rgba(255,255,255,0.08)",
                                 display:"flex", alignItems:"center", justifyContent:"center",
                                 cursor:"pointer",
                                 border:"1px solid rgba(255,255,255,0.1)",
                                 fontSize:"1.4rem"
                             }}>
                            {isVisible && <i className={`fas ${icon}`} style={{color:"#00ffa3"}}></i>}
                        </div>
                    );
                })}
            </div>

            {matched.length === pairs.length && (
                <p style={{color:"#facc15", marginTop:"1rem"}}>🎉 Hai vinto! Tutte le coppie trovate!</p>
            )}
            {timeLeft === 0 && matched.length < pairs.length && (
                <p style={{color:"#ef4444", marginTop:"1rem"}}>⏰ Tempo scaduto! Riprova!</p>
            )}
            {(matched.length === pairs.length || timeLeft === 0) && (
                <button onClick={resetGame} style={{
                    marginTop:"0.8rem",
                    background:"linear-gradient(135deg,#dc2626,#991b1b)",
                    border:"none", color:"#fff",
                    padding:"0.6rem 1.2rem",
                    borderRadius:"0.5rem",
                    cursor:"pointer"
                }}>Ricomincia</button>
            )}
        </div>
    );
}
